export class BoutiqueProduitTaille {
    /**
     * Constructeur de l'objet BoutiqueProduitTaille
     * @param contact contient les données de l'objet
     */
    constructor(produitTaille) {
        if (produitTaille) {
            const { idProduitTaille, libelle, actif } = produitTaille;
            this.idProduitTaille = idProduitTaille;
            this.libelle = libelle;
            this.actif = actif;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVQcm9kdWl0VGFpbGxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQm91dGlxdWVQcm9kdWl0VGFpbGxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sT0FBTyxxQkFBcUI7SUFnQmpDOzs7T0FHRztJQUNILFlBQW1CLGFBQThDO1FBQ2hFLElBQUksYUFBYSxFQUFFO1lBQ2xCLE1BQU0sRUFBRSxlQUFlLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxHQUFHLGFBQWEsQ0FBQztZQUUxRCxJQUFJLENBQUMsZUFBZSxHQUFHLGVBQWUsQ0FBQztZQUN2QyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztZQUN2QixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztTQUNuQjtJQUNGLENBQUM7Q0FDRCJ9